import styled, { keyframes } from "styled-components";

function setScreenSize() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

setScreenSize();

window.addEventListener("resize", () => {
  setScreenSize();
});

export const WrapContent = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap");
  display: flex;
  flex-flow: row;
  justify-content: center;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  font-family: "Roboto", sans-serif;
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 560px;
  height: calc(var(--vh, 1vh) * 100);
  //padding: 0 80px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  scroll-behavior: smooth;
  background-image: url("https://s3.ap-northeast-2.amazonaws.com/mabu.newscloud.sbs.co.kr/election2022/images/background2.png");
  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 500px) {
    width: 100%;
    padding: 0;
  }
`;

// Modal =============
export const ModalDimmed = styled.div`
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  background-color: rgba(0, 0, 0, 0.6);
`;
export const Modal = styled.div`
  z-index: 1000;
  min-width: 250px;
  min-height: 100px;
  max-width: 600px;
  max-height: 600px;
  overflow-y: scroll;
  background-color: #fff;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }
  @media screen and (max-width: 500px) {
    width: 80%;
  }
`;

// Select =============
export const SelectBtn = styled.button`
  flex: 0 0 60px;
  width: 280px;
  height: 60px;
  margin-bottom: 15px;
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.05);
  border-radius: 30px;
  background-color: #fff;
  font-size: 20px;
  font-weight: bold;
  &:hover {
    background-color: #f1f2f3;
  }
  @media screen and (max-width: 500px) {
    width: 80%;
  }
`;
export const SelectUl = styled.ul`
  width: 100%;
  min-height: 100px;
  max-height: 400px;
`;

export const SelectLi = styled.li`
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 100%;
  height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #f1f2f3;
  &:hover {
    background-color: #f1f2f3;
  }
`;
// Card =============
export const WrapCards = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  flex: 0 0 55vh;
  width: 100%;
`;

const cardRotate = (props) => keyframes`
0% {
  transform: rotate(0)
}  
15% {
  transform: rotate(${-180 + (props.idx - 1) * 45}deg);
} 
40% {
  transform: rotate(${-180 + (props.idx - 1) * 45}deg);
} 
50% {
  transform: rotate(-180deg)
} 
65% { 
  transform: rotate(${-(props.idx - 1) * 45}deg);
} 
90% {
  transform: rotate(${-(props.idx - 1) * 45}deg);
}
100% {
  transform: rotate(0deg)
}
`;

export const Cards = styled.div`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
`;

export const Card = styled.div`
  z-index: ${(props) => Math.floor(900 / props.idx)};
  position: absolute;
  left: calc(50% - 60px);
  top: -200px;
  width: 120px;
  transform-origin: bottom center;
  animation: ${(props) => cardRotate(props)} 8s linear infinite forwards;
  & > img {
    width: 120px;
    height: auto;
    border-radius: 20px;
    box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.05);
  }
`;

export const CardNotMoving = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  width: auto;
  height: 80%;
  & > img {
    width: 230px;
    height: auto;
    border-radius: 20px;
    box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.05);
    transform: rotate(-15deg);
  }
`;

// SelectDistrict =============
export const WrapSelect = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 45vh;
  padding: 20px 0;
`;
// Article =============
export const WrapArtlcle = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-height: 40vh;
  padding: 20px 80px;
  @media screen and (max-width: 500px) {
    padding: 20px 23px;
  }
`;

export const Icon = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  width: 100%;
  height: 70px;
  margin: 20px 0;

  & > img {
    width: auto;
    height: 100%;
  }
`;
export const Paragraph = styled.div`
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  margin-bottom: 20px;

  & > span {
    font-size: 20px;
    line-height: 35px;
  }
`;

export const ParagraphWithGraphLabel = styled.div`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  margin-bottom: 20px;
`;

export const GraphLabel = styled.div`
  position: absolute;
  top: 60px;
  left: calc(50% - 120px);
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  & > span {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 3px;
    color: #888;
  }
`;

// Button =============
export const BtnMore = styled.button`
  width: 150px;
  padding: 20px;
  font-size: 18px;
  font-weight: 400;
  .icon-more {
    path {
      stroke: black;
    }
  }
  &:hover {
    color: #0077c1;
    .icon-more {
      path {
        stroke: #0077c1;
      }
    }
  }
`;

export const BtnBack = styled.button`
  z-index: 999;
  position: fixed;
  top: 40px;
  left: calc(50% - 260px);
  width: 80px;
  height: 80px;
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  background-color: #fff;
  &:hover {
    background-color: #f1f2f3;
  }
  @media screen and (max-width: 500px) {
    left: 20px;
    width: 70px;
    height: 70px;
  }
`;

export const BtnHowToGraph = styled.button`
  flex: 0 0 65px;
  width: 310px;
  height: 65px;
  margin-bottom: 30px;
  border: 2px solid #ccc;
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.05);
  border-radius: 23px;
  background-color: #fff;
  font-size: 22px;
  line-height: 17px;
`;

export const BtnClose = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 23px;
  height: 23px;
`;

export const BtnLinkWithIcon = styled.a`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  flex: 0 0 65px;
  width: 470px;
  height: 65px;
  padding: 14px 20px;
  margin-bottom: 30px;
  border: 2px solid #49a0d0;
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.05);
  border-radius: 23px;
  background-color: #fff;
  font-size: 22px;
  line-height: 17px;
  & > .icon {
    width: 31px;
    height: 38px;
    margin-right: 23px;

    & > img {
      width: 100%;
      height: 100%;
    }
  }

  &:hover {
    background-color: rgba(73, 160, 208, 0.1);
  }
  @media screen and (max-width: 500px) {
    flex-flow: row nowrap;
    width: 100%;
    height: 65px;
    padding: 14px 10px;
    border-radius: 20px;
    font-size: 16px;
  }
`;
// Typography =============
export const WrapTitle = styled.div`
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
`;
export const Title = styled.h2`
  font-size: 30px;
  font-weight: 700;
`;

export const Subtitle = styled.h4`
  margin-bottom: 30px;
  font-size: 34px;
  font-weight: 400;
`;

export const GraphTitle = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #aaa;
`;

export const GraphWinnerTitle = styled.span`
  font-size: 18px;
  font-weight: 400;
  color: #0077c1;
`;
export const PointText = styled.span`
  font-weight: 700;
  color: ${(props) => (props.isColor ? "#FF0000" : "#0077c1;")};
`;

export const VoteTypeTitle = styled.span`
  font-size: 19px;
  color: #0077c1;
`;

// Graphs =============
export const WrapGraphs = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: start;
  width: 100%;
`;

export const GraphBox = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  width: 130px;
  height: auto;
  margin: 20px 0;
  @media screen and (max-width: 500px) {
    width: 33.3%;
  }
`;

export const WrapHowToGraph = styled.div`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  width: 310px;
  height: 490px;
  padding: 40px 36px;
  text-align: center;

  & > img {
    width: 90%;
    height: auto;
    max-height: 60%;
  }
`;

export const TitleHowToGraph = styled.span`
  font-size: 20px;
  font-weight: 700;
`;
export const TextHowToGraph = styled.span`
  font-size: 13px;
  line-height: 23px;
`;
// Links =============

export const WrapLink = styled.ul`
  margin: 40px 0;
`;
export const LinkTitle = styled.span`
  font-size: 34px;
  font-weight: 400;
`;

export const RelatedArticle = styled.li`
  list-style: disc;
  color: #0077c1;
  margin-bottom: 10px;
  & > a {
    font-size: 20px;
    line-height: 38px;
    color: #0077c1;
    border-bottom: 1px solid #0077c1;
  }
  @media screen and (max-width: 500px) {
    & > a {
      font-size: 16px;
    }
  }
`;

export const CoverTitleImg = styled.div`
  width: 200px;
  height: 100px;
  margin: 10px 0 30px;

  & > img {
    width: 100%;
    height: auto;
    max-height: 100%;
  }
`;

export const WrapBarGraph = styled.div`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  width: 200px;
  height: 180px;
  margin-top: 20px;
`;

export const WrapBar = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-end;
  width: 50px;
  height: 100px;
  border: 1px dashed #222;
`;
export const WrapLine = styled.div`
  position: absolute;
  top: 30px;
  left: 0;
`;
export const Bar = styled.div`
  width: 48px;
  height: ${(props) => `${props.barHeight}%`};
  background-color: #ccc;
`;

export const BarTick = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  border-top: 1px solid #ccc;
`;
